import React, { Component } from 'react';

import './Modal.css';

// @todo 2017-08-21 Bind ESC to close, bind click outside modal to close
class Modal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isVisible: props.visible,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      isVisible: nextProps.visible,
    });
  }

  render() {
    return (
      this.state.isVisible ? (
        <div className={`modal ${this.props.className}`} tabIndex="-1" role="dialog">
          <div className="modal-dialog" role="document" style={this.props.width ? { maxWidth: this.props.width } : null}>
            <div className="modal-content">
              <div className="modal-header">
                <button type="button" className="close" aria-label="Close" onClick={() => {
                  this.setState({ isVisible: false });
                  this.props.onCloseClick();
                }}>
                  <span aria-hidden="true">&times;</span>
                </button>
                {this.props.title ? (
                  <h4 className="modal-title">{this.props.title}</h4>
                ) : null}
              </div>
              <div className="modal-body">
                {this.props.children}
              </div>
              <div className={`modal-footer ${this.props.noFooterPadding ? 'u-pb-15' : 'u-pb-60'}`}>
                {this.props.actions}
              </div>
            </div>
          </div>
        </div>
      ) : null
    );
  }
}

Modal.defaultProps = {
  title: '',
  actions: [],
  visible: false,
  width: null,
  noFooterPadding: false,
  onCloseClick: console.log,
};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal.js